"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/** @jsx jsx */
var React = __importStar(require("react"));
var core_1 = require("@emotion/core");
var Theme_1 = require("../Theme");
var UnstyledLink_1 = __importDefault(require("../link/UnstyledLink"));
exports.typeStyling = function (theme) {
    return core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        @media (max-width: ", " )  {\n            display: inline-block;\n            margin-right: 5px;\n        }        \n    "], ["\n        @media (max-width: ", " )  {\n            display: inline-block;\n            margin-right: 5px;\n        }        \n    "])), Theme_1.applyTheme(theme, function (t) { return t.mobileWidth.minWidth; }));
};
exports.containerStyling = function (theme) {
    return core_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", ";\n    height: 170px;       \n    "], ["\n    padding: ", ";\n    height: 170px;       \n    "])), Theme_1.applyTheme(theme, function (t) { return t.padding.smallPadding; }));
};
var SimpleAppointment = /** @class */ (function (_super) {
    __extends(SimpleAppointment, _super);
    function SimpleAppointment() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleAppointment.prototype.render = function () {
        var _this = this;
        return (core_1.jsx(UnstyledLink_1["default"], { href: this.props.url },
            core_1.jsx("div", { onClick: this.props.onClick, css: function (t) { return [exports.containerStyling(t), _this.props.appointmentStyle !== undefined ? _this.props.appointmentStyle(t) : undefined]; } },
                core_1.jsx("p", null,
                    this.props.date,
                    " ",
                    this.props.time),
                this.props.appointmentType !== undefined ? core_1.jsx("div", { css: exports.typeStyling }, this.props.appointmentType) : null,
                core_1.jsx("div", { css: exports.typeStyling }, this.props.children))));
    };
    return SimpleAppointment;
}(React.Component));
exports["default"] = SimpleAppointment;
var templateObject_1, templateObject_2;
//# sourceMappingURL=SimpleAppointment.js.map